import type { CSSProperties } from 'react'
import { tokens } from '@/theme'
import { pulse as pulseAnimation } from './pulse'

/**
 * One placeholder bar, the unit every page-shaped skeleton is built from. A
 * skeleton keeps the page's real layout (headings, table columns, card
 * frames) and puts bars where the text will be, so nothing moves when the
 * data arrives. Width is a number of pixels or any CSS width.
 */
export function SkeletonBar({
  width = '100%',
  height = 12,
  delay = 0,
  pulse = true,
  className,
  style,
}: {
  width?: number | string
  height?: number
  /** Milliseconds, staggered down a list so the pulse reads as a wave. */
  delay?: number
  /** Off when a parent animates the whole row instead; hundreds of cells need not each pulse. */
  pulse?: boolean
  /** For a phone-width rule that resizes the bar; see skeletons/shared.ts. */
  className?: string | undefined
  style?: CSSProperties
}) {
  return (
    <span
      aria-hidden="true"
      data-skeleton=""
      className={className}
      style={{
        display: 'inline-block',
        width,
        maxWidth: '100%',
        height,
        background: tokens.paper3,
        borderRadius: tokens.radiusSm,
        animation: pulse ? pulseAnimation(delay) : undefined,
        verticalAlign: 'middle',
        ...style,
      }}
    />
  )
}
